import { Icon, Text } from "@shopify/polaris";

import { Handle, Position } from "reactflow";
import { ChatMajor, CartMajor } from "@shopify/polaris-icons";

function TriggerNode({ id, data, selected }) {
  return (
    <div
      className={(selected ? "selected " : "") + "trigger-node"}
      onClick={() => data.clickNode(id)}
    >
      <div className="row">
        {data.type === "exact_match" && (
          <>
            <Icon source={ChatMajor} />
            <div>
              <Text fontWeight="bold" variant="bodySm">
                [Message sent by the contact]
              </Text>
              <Text variant="bodySm">
                {data.text && data.text !== ""
                  ? data.text
                  : data.chatbotType === "autoreply"
                    ? "Any message that is not the trigger of a chatbot will trigger this flow"
                    : "⚠️ No trigger message defined. This chatbot can not be triggered."}
              </Text>
            </div>
          </>
        )}
        {data.type === "order" && (
          <>
            <Icon source={CartMajor} />
            <div>
              <Text fontWeight="bold" variant="bodySm">
                WhatsApp Order
              </Text>
              <Text variant="bodySm">
                Triggered when a contact places an order through WhatsApp
                catalog
              </Text>
            </div>
          </>
        )}
      </div>
      <Handle type="source" position={Position.Right} />
    </div>
  );
}

export default TriggerNode;
